import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useSession } from "../firebase/UserProvider";
import { firestore } from "../firebase/config";


import { addUserReading } from "../firebase/user";
// import { Table } from "semantic-ui-react";
import SideMenu from "../SideMenu";
import ProgressBar from "../components/ProgressBar";
import { FaBluetooth, FaBluetoothB } from 'react-icons/fa';
import { siteCode, siteLogo } from "../components/Doctors";
import { playAudio } from "../components/playAudio";
import "./AddReading.scss";

function suppressBluetoothErrorEvents() {
  window.addEventListener(
    'error',
    (event) => {
      if (
        event?.type === 'error' &&
        event?.target === null &&
        event?.currentTarget === null
      ) {
        console.warn('🛑 Suppressed unhandled Bluetooth error event:', event);
        event.preventDefault();
      }
    },
    true // capture phase
  );
}


function AddReading(props) {
  const { user } = useSession();
  const params = useParams();
  const { register, setValue, handleSubmit } = useForm();
  const [userDocument, setUserDocument] = useState(null);
  const [isLoading, setLoading] = useState(false);
  // captureImage:'Image',captureImage:{Upper:'mm Hg (Systolic)', Lower:'mm Hg (Diastolic)' ,Pulse:'bpm (Pulse Rate)'},captureImage:'Image',
  const transmit = {
    continuousGlucoseMonitor: false,
    glucoseMonitor: "Pair",
    bloodGlucoseMeter: "Pair",
    bloodPressureMonitor: "Pair",
    scale: "Pair",
    peakFlowMeter: false,
    fingertipPulseOximeter: "Pair",
  };
  const units = {
    continuousGlucoseMonitor: { Glucose: "mg/DL" },
    glucoseMonitor: { avgSp02: "mg/DL" },
    bloodGlucoseMeter: { Glucose: "mg/DL" },
    peakFlowMeter: { "Peak Flow": "I/min" },
    scale: { Weight: "lbs" },
    bloodPressureMonitor: {
      Upper: "mm Hg (Systolic)",
      Lower: "mm Hg (Diastolic)",
      Pulse: "bpm (Pulse Rate)",
    },
    fingertipPulseOximeter: {
      SpO2: "% (Oxygen Saturation)",
      PR: "bpm (Pulse Rate)",
      PI: "% (Perfusion Index)",
    },
  };
  const deviceLabel = {
    ontinuousGlucoseMonitor: "Glucose",
    bloodGlucoseMeter: "Glucose",
    peakFlowMeter: "Peak Flow",
    bloodPressureMonitor: "Upper,Lower,Pulse",
    scale: "Weight",
    fingertipPulseOximeter: "SpO2,PR,PI",
  };
  // ,'RRp™':'rpm (Respiration Rate)','PVi®':'% (Pleth Variability Index)'
  // ,RRp™,PVi®
  const dateTime = new Date(Date.now());
  const date = dateTime
    .toLocaleDateString()
    .replace(/(\d+)\/(\d+)\/(\d+)/, "$3-$1-$2");
  const time = dateTime.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  //console.log(time)
  const [completed_bpm, setCompletedBPM] = useState(0);
  const [completed_gm, setCompletedGM] = useState(0);
  const [completed_scale, setCompletedScale] = useState(0);
  const [completed_bgm, setCompletedBGM] = useState(0);
  const [completed_fpo, setCompletedFPO] = useState(0);

  const [isPaired, setIsPaired] = useState(true);
  const [isStandard, setIsStandard] = useState(false);
  useEffect(() => {
    
    localStorage.setItem("completed_bpm", 0);
    setInterval(() =>
      setCompletedBPM(localStorage.getItem("completed_bpm"), 2000)
    );
    localStorage.setItem("completed_gm", 0);
    setInterval(() =>
      setCompletedGM(localStorage.getItem("completed_gm"), 2000)
    );
    localStorage.setItem("completed_scale", 0);
    setInterval(() =>
      setCompletedScale(localStorage.getItem("completed_scale"), 2000)
    );
    localStorage.setItem("completed_bgm", 0);
    setInterval(() =>
      setCompletedBGM(localStorage.getItem("completed_bgm"), 2000)
    );
    localStorage.setItem("completed_fpo", 0);
    setInterval(() =>
      setCompletedFPO(localStorage.getItem("completed_fpo"), 2000)
    );

    const docRef = firestore.collection("users").doc(params.id);
    const unsubscribe = docRef.onSnapshot((doc) => {
      if (doc.exists) {
        const documentData = doc.data();
        //if (Object.entries(documentData)!=undefined) {
        setUserDocument(documentData);
        setIsStandard(
          documentData?.deviceInfo?.bloodPressureMonitor?.pw?.length > 4
        );
        const formData = Object.entries(documentData).map((entry) => ({
          [entry[0]]: entry[1],
        }));
        setValue(formData);
        //}
      }
    });
    return unsubscribe;
  }, [!!user && user.uid, setValue, params.id]);
  {
    /* 
  const unPairButtonClicked = () => {
    alert('unPair (temp/test) feature not finalized yet ... ')
  }
*/
  }
  const captureImage_ButtonClicked = () => {
    //alert(JSON.stringify(userDocument?.deviceInfo))
    //console.log( userDocument?.deviceInfo['bloodPressureMonitor']?.pw )
    // NEED TO CHECK IF BT Enabled
    const device = "bloodPressureMonitor";
    //playAudio(`/audio/BluetoothConnecting_${device}.mp3`)
    //.then(()=>{
    //onCaptureImageButtonClick(params.id, device, false, []);
    //})
    // https://freetts.com/ SmartViewMD is requesting access to your Bluetooth device.  After a popup window appears on your phone, please select the BP100 device and then click done.

    //alert(userDocument?.deviceInfo[device]?.pw.length )
  };
  const captureImage_ButtonClicked2 = () => {
    //alert(JSON.stringify(userDocument?.deviceInfo))
    //console.log( userDocument?.deviceInfo['bloodPressureMonitor']?.pw )
    // NEED TO CHECK IF BT Enabled
    const device = "scale";
    //playAudio(`/audio/BluetoothConnecting_${device}.mp3`)
    //.then(()=>{
    //onCaptureImageButtonClick2(params.id, device, false, []);
    //})
    // https://freetts.com/ SmartViewMD is requesting access to your Bluetooth device.  After a popup window appears on your phone, please select the BP100 device and then click done.

    //alert(userDocument?.deviceInfo[device]?.pw.length )
  };
  const captureImage_ButtonClicked3 = () => {
    //alert(JSON.stringify(userDocument?.deviceInfo))
    //console.log( userDocument?.deviceInfo['bloodPressureMonitor']?.pw )
    // NEED TO CHECK IF BT Enabled
    const device = "bloodGlucoseMeter";
    //playAudio(`/audio/BluetoothConnecting_${device}.mp3`)
    //.then(()=>{
    //onCaptureImageButtonClick3(params.id, device, false, []);
    //})
    // https://freetts.com/ SmartViewMD is requesting access to your Bluetooth device.  After a popup window appears on your phone, please select the BP100 device and then click done.

    //alert(userDocument?.deviceInfo[device]?.pw.length )
  };
  const captureImage_ButtonClicked4 = () => {
    //alert(JSON.stringify(userDocument?.deviceInfo))
    //console.log( userDocument?.deviceInfo['bloodPressureMonitor']?.pw )
    // NEED TO CHECK IF BT Enabled
    const device = "fingertipPulseOximeter";
    //playAudio(`/audio/BluetoothConnecting_${device}.mp3`)
    //.then(()=>{
    //onCaptureImageButtonClick4(params.id, device, false, []);
    //})
    // https://freetts.com/ SmartViewMD is requesting access to your Bluetooth device.  After a popup window appears on your phone, please select the BP100 device and then click done.

    //alert(userDocument?.deviceInfo[device]?.pw.length )
  };

  const glucoseMonitor_ButtonClicked = () => {
    
    suppressBluetoothErrorEvents()
    
    const device = "glucoseMonitor";
    //playAudio(`/audio/BluetoothConnecting_${device}.mp3`);
  
    const deviceInfoPW = (
      isPaired &&
      userDocument?.deviceInfo?.[device]?.pw
    ) ?? [];

    
  
    
      //onGlucoseMonitorDeviceButtonClick(
      //  params.id,
      //  device,
      //  isStandard,
      //  deviceInfoPW
      //);
    
  };

  const bloodPressureMonitor_ButtonClicked = () => {
    //alert(JSON.stringify(userDocument?.deviceInfo))
    //console.log( userDocument?.deviceInfo['bloodPressureMonitor']?.pw )
    // NEED TO CHECK IF BT Enabled
    const device = "bloodPressureMonitor";
    playAudio(`/audio/BluetoothConnecting_${device}.mp3`);
    //.then(()=>{
    //onBloodPressureMonitorDeviceButtonClick(
    //  params.id,
    //  device,
    //  isStandard,
    //  isPaired && userDocument?.deviceInfo != null
    //    ? userDocument?.deviceInfo[device]?.pw
    //    : []
    //);
    //})
    // https://freetts.com/ SmartViewMD is requesting access to your Bluetooth device.  After a popup window appears on your phone, please select the BP100 device and then click done.

    //alert(userDocument?.deviceInfo[device]?.pw.length )
  };
  const bloodGlucoseMeter_ButtonClicked = () => {
    //alert(JSON.stringify(userDocument?.deviceInfo))
    const device = "bloodGlucoseMeter";
    const audio = new Audio(`/audio/BluetoothConnecting_${device}.mp3`);
    // NiproBGM US:Joanna_Male https://freetts.com/ SmartViewMD is requesting Bluetooth access to your Blood Glucose Meter.  Please select Nypro B G M and click Pair.
    audio.play();
    //alert(device)
    //onBloodGlucoseMeterDeviceButtonClick(
    //  params.id,
    //  device,
    //  isPaired && userDocument?.deviceInfo != null
    //    ? userDocument?.deviceInfo[device]?.lastReading
    //    : []
    //);
  };
  const scale_ButtonClicked = () => {
    //alert(JSON.stringify(userDocument?.deviceInfo))
    //console.log( userDocument?.deviceInfo['scale']?.pw )
    // NEED TO CHECK IF BT Enabled
    const device = "scale";
    playAudio(`/audio/BluetoothConnecting_${device}.mp3`);
    //.then(()=>{
    //onScaleDeviceButtonClick(
    //  params.id,
    //  device,
    //  isStandard,
    //  isPaired && userDocument?.deviceInfo != null
    //    ? userDocument?.deviceInfo[device]?.pw
    //    : []
    //);
    //})
    // https://freetts.com/ SmartViewMD is requesting access to your Bluetooth device.  After a popup window appears on your phone, please select the BP100 device and then click done.

    //alert(userDocument?.deviceInfo[device]?.pw.length )
  };
  const onSubmit = async (data) => {
    console.log("DATA: ", data);
    console.log("PARAMS: ", params);
    console.log("USER: ", user);
    if (data.add.devices) {
      console.log("DATA: ", data);
      try {
        setLoading(true);
        //console.log("data: ",data.add)
        if (params.id == user.uid) {
          await addUserReading({ uid: params.id, ...data });
        } else {
          await addUserReading({
            uid: params.id,
            ...data,
            createdBy: {
              uid: user.uid,
              name: user.displayName,
              email: user.email,
              dateTime: dateTime,
            },
          });
        }
        props.history.push(`/readings/${params.id}`); //console.log("data",data.add)
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  if (userDocument == null) {
    return null;
  } else {
    const formClassname = `ui big form twelve wide column ${
      isLoading ? "loading" : ""
    }`;

    const camel2title = (camelCase) =>
      camelCase
        .replace(/([A-Z])/g, (match) => ` ${match}`)
        .replace(/^./, (match) => match.toUpperCase());

    return (
      <>
        <SideMenu id={params.id} reading />

        <div className="reading__container">
          <div className="reading__header">
            <img src={siteLogo} alt={siteCode} height="40" />
            <div></div>
          </div>
          <form
            className={`ui form ${isLoading ? "loading" : ""} reading__form`}
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="reading__grid">
              {userDocument?.devices?.map((device) => (
                <div className="reading__fullWidth" key={device}>
                  <div key={device}>
                    <div>
                      <div>
                        <h3>{camel2title(device)}</h3>
                        <br />
                        {transmit[device] ? (
                          <div>
                            
                          
                            {transmit[device] == "Pair" ? (
                              <>
                                <div
                                  className="text-white"
                                  id={`blueToothReadingsDiv${device}`}
                                >
                                  ᛒ{`blueToothReadingsDiv${device}`}
                                </div>
                                <div
                                  className=""
                                  id={`blueToothReadingsDiv${device}`}
                                >
                                  1. Please make sure you are seated.{" "}
                                </div>
                                <br></br>
                                <div
                                  className=""
                                  id={`blueToothReadingsDiv${device}`}
                                >
                                  2. Take a picture of the device screen in a
                                  room with good lighting.
                                </div>
                                <br></br>
                                <div
                                  className=""
                                  id={`blueToothReadingsDiv${device}`}
                                >
                                  3. Confirm the reading before pressing "OK".
                                </div>
                                <br></br>

                                <ProgressBar
                                  completed={
                                      device === "bloodPressureMonitor"
                                      ? completed_bpm
                                      : device === "glucoseMonitor"
                                      ? completed_gm
                                      : device === "scale"
                                      ? completed_scale
                                      : device === "bloodGlucoseMeter"
                                      ? completed_bgm
                                      : device === "fingertipPulseOximeter"
                                      ? completed_fpo
                                      : 0
                                  }
                                />
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="">
                      <div className="reading__reading-container">
                        {deviceLabel[device]
                          ? deviceLabel[device].split(",").map((read) => (
                              <div
                                className="reading__input-reading"
                                key={read}
                              >
                                <label
                                  htmlFor={`add.devices.${device}.reading.${read}`}
                                  className="reading__label"
                                >
                                  {read === "PI" ? <hr /> : ""}
                                  {read}
                                </label>
                                <div className="reading__inputWrapper">
                                  <input
                                    type="text"
                                    name={`add.devices.${device}.reading.${read}`}
                                    id={`add.devices.${device}.reading.${read}`}
                                    className="reading__input"
                                    ref={register}
                                    placeholder={units[device][read]}
                                  />
                                </div>
                              </div>
                            ))
                          : ""}

                        <div className="reading__input-reading">
                          <label
                            htmlFor={`add.devices.${device}.date`}
                            className="reading__label"
                          >
                            Date
                          </label>
                          <div className="reading__inputWrapper">
                            <input
                              className="reading__input"
                              type="text"
                              onFocus={(e) => {
                                e.currentTarget.type = "date";
                                e.currentTarget.focus();
                              }}
                              name={`add.devices.${device}.date`}
                              id={`add.devices.${device}.date`}
                              ref={register}
                              placeholder={date}
                            />
                          </div>
                        </div>
                        <div className="reading__input-reading">
                          <label
                            htmlFor={`add.devices.${device}.time`}
                            className="reading__label"
                          >
                            Time
                          </label>
                          <div className="reading__inputWrapper">
                            <input
                              className="reading__input"
                              type="text"
                              onFocus={(e) => {
                                e.currentTarget.type = "time";
                                e.currentTarget.focus();
                              }}
                              name={`add.devices.${device}.time`}
                              id={`add.devices.${device}.time`}
                              ref={register}
                              placeholder={time}
                            />
                          </div>
                        </div>
                        <div className="reading__input-reading">
                          <label
                            htmlFor={`add.devices.${device}.note`}
                            className="reading__label"
                          >
                            Note
                          </label>
                          <div className="reading__inputWrapper">
                            <input
                              className="reading__input"
                              type="text"
                              name={`add.devices.${device}.note`}
                              id={`add.devices.${device}.note`}
                              ref={register}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}{" "}
            </div>
            <div className="reading___submit-container">
              {userDocument?.devices?.length ? (
                <button type="submit" className="reading___submit">
                  Submit
                </button>
              ) : (
                <div>
                  Before adding a reading, please first select device(s) in your{" "}
                  <a href="/">profile</a>.
                </div>
              )}
            </div>
          </form>
        </div>
      </>
    );
  }
}

export default AddReading;
